<template>
  <v-row dense>
    <v-col cols="4">
      <v-text-field
        v-model="form.username"
        :label="`${$t('USERS.USERNAME')} `"
        :rules="ruleUsername"
        :readonly="readonly"
        :error-messages="errors.username"
        @input="[updateValue('username', $event), updateValue('email', $event)]"
      ></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="form.email"
        :label="$t('PROFILE.EMAIL')"
        :rules="ruleEmail"
        :readonly="readonly"
        :error-messages="errors.email"
        @input="[updateValue('email', $event), updateValue('username', $event)]"
      ></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-if="readonly"
        :label="$t('USERS.PASSWORD')"
        append-icon="mdi-eye-off"
        disabled
      ></v-text-field>

      <v-text-field
        v-else-if="!readonly"
        v-model="form.password"
        append-icon="mdi-lock-reset"
        :label="$t('USERS.NEW_PASSWORD')"
        :error-messages="errors.password"
        @click:append="generatePassword"
        @input="updateValue('password', $event)"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { textLine, email } from '@/modules/_global/variables/rules.js';
import { randomString } from '@/modules/_global/utils/str-random';

export default {
  name: 'UserInformationForm',

  mixins: [formEditable],

  data: () => ({
    ruleUsername: textLine,
    ruleEmail: email,
    form: {}
  }),

  created() {
    if (!this.readonly) {
      this.generatePassword();
      this.generateUserName();
    }
  },

  methods: {
    generatePassword() {
      let password = randomString(8);

      this.$set(this.form, 'password', password);
      this.updateValue('password', password);
    },
    generateUserName() {
      let username = randomString(25);

      this.$set(this.form, 'username', username);
      this.updateValue('username', username);
    }
  }
};
</script>

<style scoped></style>
